var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20.625 27.656",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.313 27.656s10.312-10.312 10.312-17.299c0-6.5541-5.3292-10.357-10.312-10.357s-10.313 3.803-10.313 10.357c0 6.9867 10.313 17.299 10.313 17.299zm4.7656-17.344c0 2.632-2.1336 4.7656-4.7656 4.7656s-4.7656-2.1336-4.7656-4.7656 2.1336-4.7656 4.7656-4.7656 4.7656 2.1336 4.7656 4.7656z",
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.fa05578f558ce569ca80cabf858e5575.svg";
export { ForwardRef as ReactComponent };